import React from 'react';

export const useFloatingBottomBar = ({ mainColumnRef, sidebarCollapsed }) => {
    const [bottomBarStyle, setBottomBarStyle] = React.useState({});
    const [isFloatingReady, setIsFloatingReady] = React.useState(false);

    React.useEffect(() => {
        let retryTimerId = null;

        const updateBottomBarLayout = () => {
            if (window.innerWidth < 1200) {
                setBottomBarStyle({});
                setIsFloatingReady(false);
                return;
            }

            const container = mainColumnRef.current;
            if (!container) {
                setBottomBarStyle({});
                setIsFloatingReady(false);
                retryTimerId = window.setTimeout(updateBottomBarLayout, 80);
                return;
            }

            const rect = container.getBoundingClientRect();
            const safeLeft = Math.max(Math.round(rect.left), 8);
            const safeRight = Math.max(Math.round(window.innerWidth - rect.right), 8);

            setBottomBarStyle({
                left: `${safeLeft}px`,
                right: `${safeRight}px`,
                width: 'auto',
            });
            setIsFloatingReady(true);
        };

        updateBottomBarLayout();
        const rafId = window.requestAnimationFrame(updateBottomBarLayout);
        const timerId = window.setTimeout(updateBottomBarLayout, 220);

        window.addEventListener('resize', updateBottomBarLayout);
        window.addEventListener('scroll', updateBottomBarLayout, { passive: true });
        window.addEventListener('orientationchange', updateBottomBarLayout);

        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined' && mainColumnRef.current) {
            resizeObserver = new ResizeObserver(updateBottomBarLayout);
            resizeObserver.observe(mainColumnRef.current);
        }

        return () => {
            window.cancelAnimationFrame(rafId);
            window.clearTimeout(timerId);
            if (retryTimerId) {
                window.clearTimeout(retryTimerId);
            }
            window.removeEventListener('resize', updateBottomBarLayout);
            window.removeEventListener('scroll', updateBottomBarLayout);
            window.removeEventListener('orientationchange', updateBottomBarLayout);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [mainColumnRef, sidebarCollapsed]);

    return {
        bottomBarStyle,
        isFloatingReady,
    };
};
